export default "__VITE_ASSET__C6K$oeMb__"